import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

export function initAnimations() {

    // create the scrollSmoother before your scrollTriggers
    const smoother = ScrollSmoother.create({
        smooth: 2,
        speed: 1.5,
        effects: true,
        smoothTouch: 0.1,
    });

    // Return the instance so anchor links can scroll via ScrollSmoother
    // instead of the native browser jump (which desyncs the smooth scroll).
    return smoother;

}